// Naive eTLD+1 (last two labels). Only ever compared against our own API hosts, which are all
// two-label (ahaslides.com/.eu, ahaslide.com, ahaslides.nl) — so it fails closed on multi-part TLDs.
// Don't reuse it as a general eTLD+1.
const registrableDomain = (hostname) => hostname.split('.').slice(-2).join('.')

// Generic cross-origin credentials gate. A cross-origin XHR carries the ahaToken cookie only if it's
// sent withCredentials AND answered with credentialed CORS, so enable it only where both hold: the
// request targets our API host and the page is same-site with it (same registrable domain). That's the
// EU case (presenter2.ahaslides.eu -> api-*.eu01.ahaslides.eu). It's a no-op on same-origin .com (the
// cookie is sent anyway), and excludes white-label by consequence — a custom domain has a different
// registrable and the API answers it ACAO:*, which browsers reject for credentialed requests. Only EU
// keeps this live; making a surface same-origin (incl. white-label via the proxy) retires it there.
export const shouldSendApiCredentials = (requestUrl, apiBaseUrl, pageHref) => {
  try {
    const reqHost = new URL(requestUrl, pageHref).hostname
    const apiHost = new URL(apiBaseUrl).hostname
    const pageHost = new URL(pageHref).hostname
    return reqHost === apiHost && registrableDomain(reqHost) === registrableDomain(pageHost)
  } catch (e) {
    return false
  }
}
